
export default {
  'footer.platform': 'Plateforme',
  'footer.explore': 'Explorer',
  'footer.how_it_works': 'Comment ça marche',
  'footer.pricing': 'Tarifs',
  'footer.security': 'Sécurité',
  'footer.resources': 'Ressources',
  'footer.blog': 'Blog',
  'footer.faq': 'FAQ',
  'footer.safety_tips': 'Conseils de sécurité',
  'footer.support': 'Support',
  'footer.legal': 'Mentions légales',
  'footer.terms': 'Conditions générales',
  'footer.privacy': 'Politique de confidentialité',
  'footer.cookies': 'Politique des cookies',
  'footer.content_policy': 'Politique de contenu',
  'footer.rights': 'Tous droits réservés',
  'footer.currency': 'Devise',
  'footer.about': 'À propos',
  'footer.contact': 'Contact',
  'footer.copyright': 'Tous droits réservés'
};
